import React from 'react';
import { Box, Typography } from '@mui/material';
import { resolveAssetUrl } from '../api';
import { useT } from '../localization/LocalizationProvider';

export function PlayerHeader({ appName, quizTitle, logoUrl, showLogo = true }) {
  const t = useT();
  const resolvedAppName = appName || t('Common.AppName');
  const resolvedQuizTitle = quizTitle || resolvedAppName;

  return (
    <Box sx={{ textAlign: 'center' }}>
      {showLogo && logoUrl && (
        <Box
          component="img"
          src={resolveAssetUrl(logoUrl)}
          alt={t('Player.Header.LogoAlt')}
          sx={{
            display: 'block',
            mx: 'auto',
            mb: 2,
            maxWidth: { xs: 180, sm: 240 },
            maxHeight: { xs: 90, sm: 120 },
            objectFit: 'contain'
          }}
        />
      )}
      <Typography variant="overline" sx={{ letterSpacing: 1.1, color: 'text.secondary' }}>
        {resolvedAppName}
      </Typography>
      <Typography variant="h4">{resolvedQuizTitle}</Typography>
    </Box>
  );
}
